var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.5,
    r: 5.5,
    fill: "#E4FAE4",
    fillOpacity: 0.675
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.9122 0 3.84884 0.322569 2.94437 0.926917C2.0399 1.53126 1.33495 2.39025 0.918665 3.39524C0.502383 4.40023 0.393465 5.5061 0.605683 6.573C0.817902 7.63989 1.34173 8.6199 2.11091 9.38909C2.8801 10.1583 3.86011 10.6821 4.92701 10.8943C5.9939 11.1065 7.09977 10.9976 8.10476 10.5813C9.10975 10.1651 9.96874 9.4601 10.5731 8.55564C11.1774 7.65117 11.5 6.5878 11.5 5.5C11.4984 4.0418 10.9184 2.64378 9.88732 1.61268C8.85622 0.581578 7.4582 0.00160138 6 0ZM6 9.9C5.12976 9.9 4.27907 9.64194 3.55549 9.15847C2.83192 8.67499 2.26796 7.9878 1.93493 7.18381C1.60191 6.37981 1.51477 5.49512 1.68455 4.6416C1.85432 3.78809 2.27338 3.00408 2.88873 2.38873C3.50408 1.77338 4.28809 1.35432 5.1416 1.18454C5.99512 1.01477 6.87981 1.1019 7.68381 1.43493C8.4878 1.76796 9.17499 2.33191 9.65847 3.05549C10.1419 3.77907 10.4 4.62976 10.4 5.5C10.3987 6.66655 9.9347 7.78495 9.10982 8.60982C8.28495 9.4347 7.16655 9.89869 6 9.9Z",
    fill: "#75BA88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36113 3.46118L5.44998 6.37233L4.18883 5.11118L3.41113 5.88888L5.44998 7.92773L9.13883 4.23888L8.36113 3.46118Z",
    fill: "#75BA88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d6b392a4f3c921c31a1b0830fb61754b.svg";
export { ForwardRef as ReactComponent };